import { AxiosResponse } from "axios";
import service from "./index";
import CDCHttpService from "./CDCHttpService";
const prefix = '/notifications';
export const queryTemplateList = (
  params: API.TemplatePageParams
): Promise<AxiosResponse<API.PageResult<API.TemplateDetail[]>, any>> => {
  return service.get(`${prefix}/templates`, { params });
};

export const addTemplate = (
  templateInfo?: API.TemplateVO
) => {
  return service.post(`${prefix}/templates`, templateInfo);
};

export const getTemplateDetail = (
  templateId: number
): Promise<AxiosResponse<API.TemplateDetail, any>> => {
  return service.get(`${prefix}/templates/${templateId}`);
};

export const updateTemplate = (
  templateId: number,
  templateInfo?: API.TemplateVO
) =>
  service.put(`${prefix}/templates/${templateId}`, templateInfo);

export const deleteTemplate = (
  templateId: number
) => service.delete(`${prefix}/templates/${templateId}`);

export const getCDCEnabled = (
  tenantId: string
): Promise<AxiosResponse<{ code: number; message: string; data: boolean }, any>> => {
  return CDCHttpService.get(`/notification/tenants/${tenantId}/cdc-enabled`);
};

// CDC subscription modules
/** Scheduler Frequency support switched on for the current tenant's module. */
export interface FrequencyCapabilities {
  conditions?: boolean | null;
  group_by?: boolean | null;
}

export interface CDCSubscriptionModule {
  moduleCode: string;
  moduleId: number;
  moduleName: string;
  domainName: string;
  domainId: number;
  /** null when the tenant's module was never switched on. */
  frequency?: FrequencyCapabilities | null;
}

export const getCDCSubscriptionModules = (): Promise<
  AxiosResponse<{ code: number; message: string; data: CDCSubscriptionModule[] }, any>
> => {
  return CDCHttpService.get(`/notification/tenants/subscription/modules`);
};